import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InputWrapperComponent } from "./input-wrapper.component";

@NgModule({
  imports: [CommonModule],
  declarations: [InputWrapperComponent],
  exports: [InputWrapperComponent]
})
export class InputWrapperModule {}
